import OVERLAYS from 'constants/overlays';
import { useContext, useEffect } from 'react';
import { Context } from 'state/store';
import { setOverlay } from 'state/creators';
import { useIsMobile } from '@nbx/frontend-helpers/misc';

export const useInstantTradeRedirect = (): void => {
  const [, dispatch] = useContext(Context);
  const isMobile = useIsMobile();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    if (action === 'paymentRedirect') {
      if (
        (!window.location.search.includes('dashboards') || isMobile) &&
        !window.location.search.includes('quickbuy')
      )
        dispatch(setOverlay(OVERLAYS.quickbuy));
    }
  }, [dispatch, isMobile]);
};
